import { Col, Row } from 'react-bootstrap';
import { getNumber, getString, getYesNoUnknown } from './renderers';
import { IDonorRegistration } from '@nkr/models/index';
import { cardBodyStyle, cardBodyTitleStyle, cardStyle, cardBodyTitleTextStyle } from '../../styles';

interface IProps {
    data: IDonorRegistration
}

const LivingDonorFamilyMedicalHistory = (props: IProps) => {
    return (
        <div id='living-donor-family-medical-history' style={cardStyle}>
            <div style={cardBodyStyle}>
                <div style={cardBodyTitleStyle}>
                    <span style={cardBodyTitleTextStyle}>Living Donor Family Medical History</span>
                </div>
                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Anyone with kidney disease?</Col>
                    <Col xs={6} sm={4}>
                        {getYesNoUnknown(props.data.familyHistoryKidneyDisease)}
                    </Col>
                </Row>
                {props.data.familyHistoryKidneyDisease == 'Yes' && (
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8} className='item-label'>&nbsp; - which family members:</Col>
                        <Col xs={6} sm={4}>{props.data.familyMembersKidneyDisease}</Col>
                    </Row>
                )}

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Anyone with liver disease?</Col>
                    <Col xs={6} sm={4}>
                        {getYesNoUnknown(props.data.familyHistoryLiverDisease)}
                    </Col>
                </Row>

                {props.data.familyHistoryLiverDisease == 'Yes' && (
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8} className='item-label'>&nbsp; - which family members:</Col>
                        <Col xs={6} sm={4}>{props.data.familyMembersLiverDisease}</Col>
                    </Row>
                )}

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Anyone with heart disease?</Col>
                    <Col xs={6} sm={4}>
                        {getYesNoUnknown(props.data.familyHistoryHeartDisease)}
                    </Col>
                </Row>
                {props.data.familyHistoryHeartDisease == 'Yes' && (
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8} className='item-label'>&nbsp; - which family members:</Col>
                        <Col xs={6} sm={4}>{props.data.familyMembersHeartDisease}</Col>
                    </Row>
                )}

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Anyone with coronary artery disease?</Col>
                    <Col xs={6} sm={4}>
                        {getYesNoUnknown(props.data.familyHistoryCad)}
                    </Col>
                </Row>
                {props.data.familyHistoryCad == 'Yes' && (
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8} className='item-label'>&nbsp; - which family members:</Col>
                        <Col xs={6} sm={4}>{props.data.familyMembersCad}</Col>
                    </Row>
                )}

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Anyone with high blood pressure?</Col>
                    <Col xs={6} sm={4}>
                        {getYesNoUnknown(props.data.familyHistoryBloodPressure)}
                    </Col>
                </Row>
                {props.data.familyHistoryBloodPressure == 'Yes' && (
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8} className='item-label'>&nbsp; - which family members:</Col>
                        <Col xs={6} sm={4}>{props.data.familyMembersBloodPressure}</Col>
                    </Row>
                )}

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Anyone with blood disorder?</Col>
                    <Col xs={6} sm={4}>
                        {getYesNoUnknown(props.data.familyHistoryBloodDisorder)}
                    </Col>
                </Row>
                {props.data.familyHistoryBloodDisorder == 'Yes' && (
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8} className='item-label'>&nbsp; - which family members:</Col>
                        <Col xs={6} sm={4}>{props.data.familyMembersBloodDisorder}</Col>
                    </Row>
                )}

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Anyone with cancer?</Col>
                    <Col xs={6} sm={4}>
                        {getYesNoUnknown(props.data.familyHistoryCancer)}
                    </Col>
                </Row>
                {props.data.familyHistoryCancer == 'Yes' && (
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8} className='item-label'>&nbsp; - which family members:</Col>
                        <Col xs={6} sm={4}>{props.data.familyMembersCancer}</Col>
                    </Row>
                )}

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Anyone with kidney cancer?</Col>
                    <Col xs={6} sm={4}>
                        {getYesNoUnknown(props.data.familyHistoryKidneyCancer)}
                    </Col>
                </Row>
                {props.data.familyHistoryKidneyCancer == 'Yes' && (
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8} className='item-label'>&nbsp; - which family members:</Col>
                        <Col xs={6} sm={4}>{props.data.familyMembersKidneyCancer}</Col>
                    </Row>
                )}

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Anyone with diabetes?</Col>
                    <Col xs={6} sm={4}>
                        {getYesNoUnknown(props.data.familyHistoryDiabetes)}
                    </Col>
                </Row>

                {props.data.familyHistoryDiabetes == 'Yes' && (
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8} className='item-label'>&nbsp; - which family members:</Col>
                        <Col xs={6} sm={4}>{props.data.familyMembersDiabetes}</Col>
                    </Row>
                )}

                {/* <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Is mother alive?</Col>
                    <Col xs={6} sm={4}>
                        {getYesNoUnknown(props.data.isMotherAlive, false)}
                    </Col>
                </Row> */}

                {/* {props.data.isMotherAlive != 'Unknown' && (
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8} className='item-label'>
                            Mother's age{props.data.isMotherAlive == null || props.data.isMotherAlive == "Yes" ? '' : ' at time of death'}?
                        </Col>
                        <Col xs={6} sm={4}>
                            {getNumber(props.data.mothersLastAge)}
                        </Col>
                    </Row>
                )}

                {props.data.isMotherAlive == 'No' && (
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8} className='item-label'>
                            Mother's cause of death?
                        </Col>
                        <Col xs={6} sm={4}>
                            {getYesNoUnknown(props.data.motherCauseOfDeath)}
                        </Col>
                    </Row>
                )} */}

                {/* <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>Is father alive?</Col>
                    <Col xs={6} sm={4}>
                        {getYesNoUnknown(props.data.isFatherAlive, false)}
                    </Col>
                </Row>

                {props.data.isFatherAlive != 'Unknown' && (
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8} className='item-label'>
                            Father's age{props.data.isFatherAlive == null || props.data.isFatherAlive == "Yes" ? '' : ' at time of death'}?
                        </Col>
                        <Col xs={6} sm={4}>
                            {getNumber(props.data.fathersLastAge)}
                        </Col>
                    </Row>
                )}

                {props.data.isFatherAlive == 'No' && (
                    <Row className='row-underlined row-value-center'>
                        <Col xs={6} sm={8} className='item-label'>
                            Father's cause of death?
                        </Col>
                        <Col xs={6} sm={4}>
                            {getString(props.data.fatherCauseOfDeath)}
                        </Col>
                    </Row>
                )} */}

                {/* <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>How many siblings?</Col>
                    <Col xs={6} sm={4}>
                        {getNumber(props.data.howManySiblings)}
                    </Col>
                </Row>

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>How many adult children?</Col>
                    <Col xs={6} sm={4}>
                        {getNumber(props.data.howManyAdultChildren)}
                    </Col>
                </Row>

                <Row className='row-underlined row-value-center'>
                    <Col xs={6} sm={8} className='item-label'>How many children under 18?</Col>
                    <Col xs={6} sm={4}>
                        {getNumber(props.data.howManyUnderAgeChildren)}
                    </Col>
                </Row> */}
            </div>
        </div>
    );
}

export default LivingDonorFamilyMedicalHistory;